import { get } from "http";
import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useStoreApi() {
  const callApi = useApiCall();

  const addStore = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.STORE.ADD_STORE, data, onSuccess, onError);
  };
  
  const getStore = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.STORE.GET_STORE, data, onSuccess, onError);
 }

 const getStoreBranches = (data: any, onSuccess: Function, onError: Function) => {
  callApi(SAGA_ACTIONS.STORE.BRANCH_LIST, data, onSuccess, onError);
}

const updateStoreInfo = (data: any, onSuccess: Function, onError: Function) => {
  callApi(SAGA_ACTIONS.STORE.UPDATE_STORE, data, onSuccess, onError);
};

const addStoreBranch = (data: any, onSuccess: Function, onError: Function) => {
  callApi(SAGA_ACTIONS.STORE.ADD_BRANCH, data, onSuccess, onError);
};

const updateStoreBranchInfo = (data: any, onSuccess: Function, onError: Function) => {
  callApi(SAGA_ACTIONS.STORE.UPDATE_BRANCH, data, onSuccess, onError);
};

const getStoreTypes = (data: any, onSuccess: Function, onError: Function) => {
  callApi(SAGA_ACTIONS.STORE.GET_STORE_TYPE, data, onSuccess, onError);
};

  return {
    addStore,
    getStore,
    getStoreBranches,
    updateStoreInfo,
    addStoreBranch,
    updateStoreBranchInfo,
    getStoreTypes,
  };
}
